import React from 'react';
import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';

const StyledButton = styled(Button, {
  shouldForwardProp: prop => prop !== 'buttonVariant',
})(({ buttonVariant }) => ({
  textTransform: 'none',
  boxShadow: 'none',
  '&:hover': {
    boxShadow: 'none',
  },
  // 검색 인풋 옆에 붙는 outlined teal 검색 버튼 (기본).
  ...(buttonVariant === 'compact' && {
    minWidth: '56px',
    height: '40px',
    padding: '10px',
    borderRadius: '4px',
    border: '1px solid #58B9C1',
    borderWidth: '2px',
    backgroundColor: '#58B9C1',
    color: '#fff',
    fontSize: '16px',
    fontWeight: 500,
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: '#58B9C1',
    },
  }),
  // 필터 영역의 메인 검색 제출 버튼 (Attendance/Employee 류).
  ...(buttonVariant === 'primary' && {
    minWidth: 80,
    height: 40,
    backgroundColor: '#0F7F85',
    color: '#fff',
    fontSize: '14px',
    fontWeight: 500,
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: '#0a5a5e',
    },
  }),
}));

const CommonSearchSubmitButton = ({ variant = 'compact', children, ...rest }) => (
  <StyledButton variant="contained" buttonVariant={variant} {...rest}>
    {children}
  </StyledButton>
);

export default CommonSearchSubmitButton;
